const StepSubtitle = ({ text }: { text: string }) => {
  return (
    <p className="text-base font-semibold text-content-base-subdued">{text}</p>
  );
};

export default StepSubtitle;
